<template>
  <NotificationForTopPage  v-if="isLoggedIn"/>
    <div class="navigation-shell" id="nav">
      <header>
        
        <nav class="navbar navbar-expand-xl bg-white">
          <div class="container-fluid navigation-container">

            <!-- Logo -->
            <router-link to="/" class="navbar-brand d-flex align-items-center gap-2">
              <img src="../../assets/images/lengedu.jpg" class="brand-logo" alt="Lengedu">
            </router-link>

            <!-- Hamburger: xl altı görünür -->
            <button 
              class="navbar-toggler border-0"
              type="button"
              @click="toggleOffcanvas"
              aria-label="Menüyü aç" aria-controls="mainNavbar"
            >
              <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Menü: xl+’da normal navbar gibi, xl altı sağdan offcanvas -->
            <div class="offcanvas offcanvas-end offcanvas-xl" tabindex="-1" aria-labelledby="mainMenuLabel" id="mainNavbar">
              <div class="offcanvas-header d-xl-none border-bottom">
                <h5 class="offcanvas-title fw-bold" id="mainMenuLabel">Menü</h5>
                <button 
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Kapat"
                ></button>
              </div>

              <div class="offcanvas-body">
                <ul class="navbar-nav align-items-xl-center">
                  <li class="nav-item">
                    <a href="javascript:;" @click="goPage('/')" class="nav-link" :class="{ active: isHomeActive, 'router-link-active':isHomeActive, 'router-link-exact-active':isHomeActive }">
                      <i class="bi bi-house me-2"></i>Ana Sayfa
                    </a>
                  </li>
                  
                  <li class="nav-item">
                    <a href="javascript:;" @click="goPage('/my-education')" class="nav-link" :class="{ active: isEducationActive, 'router-link-active': isEducationActive, 'router-link-exact-active': isEducationActive }">
                      <i class="bi bi-mortarboard me-2"></i>Eğitim Planım
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="javascript:;" @click="goPage('/lesson-schedule')" class="nav-link" :class="{ active: isLessonActive, 'router-link-active':isLessonActive, 'router-link-exact-active':isLessonActive }">
                      <i class="bi bi-calendar3 me-2"></i>Ders Takvimi
                    </a>
                  </li>

                  <li class="nav-item">
                    <a href="javascript:;" @click="goPage('/excercises')" class="nav-link" :class="{ active: isExcercisesActive, 'router-link-active':isExcercisesActive, 'router-link-exact-active':isExcercisesActive }">
                      <i class="bi bi-stopwatch me-2"></i>Egzersizler
                    </a>
                  </li>

                  <li class="nav-item" >
                    <a href="javascript:;" @click="goPage('/market')" class="nav-link d-flex align-items-center gap-2" :class="{ active: isMarketActive, 'router-link-active':isMarketActive, 'router-link-exact-active':isMarketActive }" >
                      <i class="bi bi-shop-window me-1"></i>Eğitim Paketleri
                    </a>
                  </li>

                  <li class="nav-item" >
                    <a href="javascript:;" @click="goPage('/invite')" class="nav-link d-flex align-items-center gap-2" :class="{ active: isInviteActive, 'router-link-active':isInviteActive, 'router-link-exact-active':isInviteActive }">
                      <i class="bi bi-share me-1"></i>Arkadaşını Davet Et
                    </a>
                  </li>

                  <!-- Profil: PC’de sağda, mobilde listede -->
                  <li class="nav-item dropdown account-menu ms-xl-auto">
                    <a href="javascript:;"
                      class="nav-link account-toggle dropdown-toggle d-flex align-items-center gap-2" role="button" aria-label="Hesabım" aria-expanded="false"
                      data-bs-toggle="dropdown">
                      <img src="../../assets/images/profile/default.png" width="32" height="32" class="rounded-circle bg-light" alt="">
                      <span class="d-xl-none">Hesabım</span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><router-link class="dropdown-item" to="/profile" @click="forceCloseOffcanvas"><i class="bi bi-person me-2" aria-hidden="true"></i>Profilim</router-link></li>
                      <li><a class="dropdown-item" href="javascript:;" @click="goPage('/faq')"><i class="bi bi-question-circle me-2"></i>Sıkça Sorulan Sorular</a></li>
                      <li><hr class="dropdown-divider"></li>
                      <li><a class="dropdown-item text-danger" href="javascript:;" @click="logout()"><i class="bi bi-box-arrow-right me-2"></i>Çıkış Yap</a></li>
                    </ul>
                  </li>

                </ul>
              </div>
            </div>

          </div>
        </nav>
      </header>
    </div>
    <NotificationForMeeting v-if="isLoggedIn"></NotificationForMeeting>
</template>
  <script>
  import { Offcanvas  } from "bootstrap";
  import NotificationForMeeting from "@/components/Shared/NotificationForMeeting.vue";
  import NotificationForTopPage from "@/components/Shared/NotificationForTopPage.vue";
  import store from "@/store";
  //import * as bootstrap from 'bootstrap'
  export default {
    name: "NavBar",
    data(){
      return{
        currentUserName:'',
        mqXl: null,
        onMqChange: null,
      }
    },
    components: {
      NotificationForTopPage,
      NotificationForMeeting
    },
    computed: {
      isLoggedIn: function() {
        return this.$store.getters.isAuthenticated;
      },
      isDemoCreated: function() {
        return this.$store.getters.isDemoCreate;
      },
      isMarketActive:function() {
        let isActive = this.$route.matched.some(r =>
          r.path === "/market" ||
          r.path.startsWith("/market") ||
          (r.name && String(r.name).startsWith("market"))
        );
        return isActive;
      },
      isLessonActive:function() {
        let isActive = this.$route.matched.some(r =>
          r.path === "/lesson-schedule" ||
          r.path.startsWith("/lesson-schedule") ||
          (r.name && String(r.name).startsWith("LessonSchedule")) ||
          r.path.startsWith("/courses/") ||
          (r.name && String(r.name).startsWith("courses"))
        );
        return isActive;
      },
      isExcercisesActive:function() {
        let isActive = this.$route.matched.some(r =>
          r.path === "/excercises" ||
          r.path.startsWith("/excercises") ||
          (r.name && String(r.name).startsWith("excercises"))
        );
        return isActive;
      },
      isHomeActive() {
        return this.$route.name === 'Home';
      },
      isEducationActive() {
        return ['MyEducation', 'Training'].includes(this.$route.name);
      },
      isInviteActive:function() {
        let isActive = this.$route.matched.some(r =>
          r.path === "/invite" ||
          r.path.startsWith("/invite") ||
          (r.name && String(r.name).startsWith("invite"))
        );
        return isActive;
      },
    },
    methods: {
      async logout() {
        this.forceCloseOffcanvas();
        if (window.globalTimer) {
          clearInterval(window.globalTimer);
          window.globalTimer = null;
        }

        await this.$store.dispatch("ClearProfile");
        await this.$store.dispatch("LogOut");
        this.$router.push("/login");
      },
      getOffcanvasEl() {
        return document.getElementById("mainNavbar");
      },
      getOffcanvasInstance() {
        const el = this.getOffcanvasEl();
        if (!el) return null;
        return Offcanvas.getOrCreateInstance(el);
      },
      // Hamburger'a basınca istersen bunu çağırabilirsin
      toggleOffcanvas() {
        // XL+ modda offcanvas davranışı zaten devre dışı.
        // Yine de yanlışlıkla açılmasın diye koruma:
        if (window.innerWidth >= 1200) return;

        const instance = this.getOffcanvasInstance();
        if (instance) instance.toggle();
      },
      // Desktop'a geçince veya gerektiğinde state temizle
      forceCloseOffcanvas() {
        const el = this.getOffcanvasEl();
        if (!el) return;

        const instance = this.getOffcanvasInstance();
        if (instance) instance.hide();

        // Backdrop kaldıysa temizle
        document.querySelectorAll(".offcanvas-backdrop").forEach((b) => b.remove());

        // Body kilitliyse aç
        document.body.classList.remove("overflow-hidden");
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");

        // Element üzerinde kalan state'leri temizle (nadiren gerekir ama garanti)
        el.classList.remove("show");
        el.removeAttribute("aria-modal");
        el.removeAttribute("role");
        el.style.removeProperty("visibility");
        el.style.removeProperty("transform");
      },
      // İstersen açık/kapalı kontrol
      isOffcanvasOpen() {
        const el = this.getOffcanvasEl();
        return !!el && el.classList.contains("show");
      },
      goPage(url){
        this.forceCloseOffcanvas();
        this.$router.push(url);
      }
    },
    mounted:function(){
      let nameSurname = store.getters['NameSurname'];
      window.metrica(97130115, "params", {nameSurname:nameSurname});
      
      // XL breakpoint (Bootstrap)
      this.mqXl = window.matchMedia("(min-width: 1200px)");

      // Desktop'a geçince offcanvas state temizle
      this.onMqChange = (e) => {
        if (e.matches) {
          this.forceCloseOffcanvas();
        }
      };

      // İlk yüklemede de kontrol et
      if (this.mqXl.matches) {
        this.forceCloseOffcanvas();
      }

      this.mqXl.addEventListener("change", this.onMqChange);

    },
    beforeUnmount() {
     if (this.mqXl && this.onMqChange) {
        this.mqXl.removeEventListener("change", this.onMqChange);
      }
    },
  };
  </script>
  
  <style scoped>
.navigation-shell {
  position: relative;
  z-index: 1030;
  border-bottom: 1px solid #e9eeea;
  background: #fff;
  box-shadow: 0 4px 20px rgb(25 48 34 / 3%);
}

.navbar {
  padding: 14px 0;
}

.navigation-container {
  gap: 20px;
  padding-inline: clamp(16px, 2vw, 36px);
}

.navbar-brand {
  flex-shrink: 0;
  margin: 0;
  padding: 0;
}

.brand-logo {
  display: block;
  width: 110px;
  height: auto;
}

.offcanvas-body {
  min-width: 0;
}

.navbar-nav {
  width: 100%;
  gap: 4px;
}

.navbar-nav .nav-link {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 11px;
  border: 0;
  border-radius: 10px;
  color: #647069;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
  text-decoration: none;
  transition: color 160ms ease, background-color 160ms ease;
}

.navbar-nav .nav-link > i {
  margin: 0 !important;
  font-size: 17px;
  line-height: 1;
}

.navbar-nav .nav-link:hover {
  color: #293e30;
  background: #f4f7f4;
}

.navbar-nav .nav-link.active {
  color: var(--brand-link);
  background: #edf7ee;
  font-weight: 600;
}

.nav-link:focus-visible,
.dropdown-item:focus-visible,
.navbar-brand:focus-visible,
.navbar-toggler:focus-visible,
.btn-close:focus-visible {
  outline: 3px solid #83c990;
  outline-offset: 3px;
  box-shadow: none;
}

.menu-badge {
  padding: 4px 6px;
  background: #edf7ee;
  color: var(--brand-link);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: .02em;
}

.active .menu-badge {
  background: #d9eddd;
}

.account-menu {
  padding-left: 14px;
  margin-left: 10px;
  border-left: 1px solid #e9eeea;
}

.navbar-nav .account-toggle {
  gap: 8px;
  padding: 5px 7px;
}

.account-toggle img {
  width: 34px;
  height: 34px;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #e5ebe6;
}

.dropdown-toggle::after {
  color: #8a958d;
}

.dropdown-menu {
  min-width: 230px;
  margin-top: 12px;
  padding: 7px;
  border: 1px solid #e9eeea;
  border-radius: 14px;
  box-shadow: 0 12px 36px rgb(25 48 34 / 10%);
}

.dropdown-item {
  padding: 10px 12px;
  border-radius: 8px;
  color: #4c5d51;
  font-size: 13px;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background: #f1f6f2;
}

.dropdown-divider {
  margin: 6px 4px;
  border-color: #e9eeea;
}

.navbar-toggler {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 8px;
  border-radius: 12px;
  background: #f4f7f4;
}

.navbar-toggler-icon {
  width: 22px;
  height: 22px;
}

@media (min-width: 1200px) {
  .navigation-container {
    gap: clamp(32px, 3vw, 56px);
  }

  .navbar-toggler {
    display: none;
  }

  .navbar-nav > .nav-item:first-child {
    margin-inline-start: auto;
  }

  .navbar-nav > .nav-item {
    flex-shrink: 0;
  }
}

@media (min-width: 1200px) and (max-width: 1399.98px) {
  .navigation-container {
    gap: 28px;
    padding-inline: 18px;
  }

  .brand-logo {
    width: 92px;
  }

  .navbar-nav {
    gap: 2px;
  }

  .navbar-nav .nav-link {
    gap: 5px;
    padding-inline: 7px;
    font-size: 12px;
  }

  .navbar-nav .nav-link > i {
    font-size: 15px;
  }

  .account-menu {
    padding-left: 8px;
  }
}

@media (max-width: 1199.98px) {
  .navbar {
    padding-block: 10px;
  }

  #mainNavbar {
    --bs-offcanvas-width: 340px;
    max-width: 90vw;
    border-left: 1px solid #e9eeea;
    background: #fff;
  }

  .offcanvas-header {
    min-height: 80px;
    padding: 22px;
    border-color: #e9eeea !important;
  }

  .offcanvas-title {
    color: #293e30;
    font-size: 18px;
  }

  .offcanvas-body {
    padding: 16px;
  }

  .navbar-nav {
    gap: 6px;
  }

  .navbar-nav .nav-link {
    gap: 12px;
    min-height: 48px;
    padding: 12px 14px;
    font-size: 14px;
    border-radius: 12px;
  }

  .navbar-nav .nav-link > i {
    font-size: 19px;
  }

  .menu-badge {
    margin-left: auto;
    font-size: 10px;
  }

  .account-menu {
    margin: 14px 0 0;
    padding: 14px 0 0;
    border-top: 1px solid #e9eeea;
    border-left: 0;
  }

  .account-toggle::after {
    margin-left: auto;
  }

  .account-menu .dropdown-menu {
    margin-top: 8px;
    box-shadow: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .navbar-nav .nav-link {
    transition: none;
  }
}
</style>
